import { Component, inject } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';

@Component({
  selector: 'app-loader',
  imports: [],
  template: `
    @if (loaderService.isLoading()) {
      <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-base-100/60 backdrop-blur-sm">
        <span class="loading loading-spinner loading-lg text-primary"></span>
      </div>
    }
  `,
})
export class LoaderComponent {
  loaderService = inject(LoaderService);
}
